import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";

interface PasswordSuccessModalProps {
  open: boolean;
  onClose: () => void;
}

export function PasswordSuccessModal({ open, onClose }: PasswordSuccessModalProps) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="bg-[#15203c] border-[#5d5d5d] max-w-[500px]">
        <DialogHeader>
          <div className="flex flex-col items-center gap-[20px] py-[20px]">
            {/* Success Icon */}
            <div className="w-[80px] h-[80px] bg-[#13d480]/10 rounded-full flex items-center justify-center">
              <CheckCircle2 className="w-[50px] h-[50px] text-[#13d480]" />
            </div>

            {/* Title */}
            <DialogTitle className="font-['Plus_Jakarta_Sans'] font-bold text-[24px] text-white text-center">
              Senha Alterada com Sucesso!
            </DialogTitle>

            {/* Description */}
            <p className="font-['Plus_Jakarta_Sans'] font-normal text-[16px] text-[#d1d1d1] text-center leading-normal">
              Sua senha foi atualizada com sucesso. Você pode continuar usando a plataforma normalmente.
            </p>

            {/* Close Button */}
            <Button
              onClick={onClose}
              className="bg-[#7846ff] hover:bg-[#6535e8] text-white font-['Plus_Jakarta_Sans'] font-bold text-[16px] px-[40px] py-[12px] rounded-[10px] mt-[10px]"
            >
              Entendido
            </Button>
          </div>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
}

PasswordSuccessModal.displayName = "PasswordSuccessModal";
